/**
 * Application version / build number.
 *
 * The build number in buildNumber.json is auto-incremented by 0.001
 * on every production build via scripts/increment-build.js.
 */

import buildData from './buildNumber.json';

export const BUILD_NUMBER: string = buildData.buildNumber.toFixed(3);
export const BUILD_TIMESTAMP: string = buildData.buildTimestamp || '';
export const VERSION_LABEL = BUILD_TIMESTAMP
  ? `${BUILD_NUMBER} GA — ${BUILD_TIMESTAMP}`
  : `${BUILD_NUMBER} GA`;

